module.exports = __webpack_public_path__ + "img/schef-works.e1e3dd39.jpg";